import { createFileRoute, useParams, useSearch } from "@tanstack/react-router";
import { UpgradePage } from "@/pages/upgrade";

type UpgradeSearch = {
  feature: string;
};

const UpgradeRoute = () => {
  const { companySlug } = useParams({
    from: "/_authed/_noSidebar/$companySlug/upgrade",
  });
  const { feature } = useSearch({
    from: "/_authed/_noSidebar/$companySlug/upgrade",
  });

  return <UpgradePage feature={feature} companySlug={companySlug} />;
};

export const Route = createFileRoute(
  "/_authed/_noSidebar/$companySlug/upgrade",
)({
  validateSearch: (search: Record<string, unknown>): UpgradeSearch => ({
    feature: (search.feature as string) ?? "",
  }),
  component: UpgradeRoute,
});
